import clsx from 'clsx';
import FullWrapper from 'core/FullWrapper';
import React from 'react';
import MapBody from 'shared/sections/Map/MapBody';

import cn from './style.module.sass';

type MapProps = {
    showMap: boolean;
    currentCity: string;
};

export default function Map({ showMap, currentCity }: MapProps) {
    return (
        <section
            className={showMap ? clsx(cn['main-map'], cn['main-map--active']) : cn['main-map']}
        >
            <FullWrapper className={cn['main-map__wrapper']}>
                <MapBody showMap={showMap} currentCity={currentCity} />
            </FullWrapper>
        </section>
    );
}
